module.exports = __webpack_public_path__ + "images/premium4-426978b2e08c2145bf2d9735d966a8dc.jpg";